import { Controller } from "@hotwired/stimulus"

// Disables the path input and sets its value when a notification source is selected.
export default class extends Controller {
  connect() {
    this.sourceSelect = document.getElementById("notification_source_identifier")
    this.pathInput = this.element.querySelector('input[name="notification[path]"]')
    if (!this.sourceSelect || !this.pathInput) return

    this.boundUpdate = this.updatePathField.bind(this)
    this.sourceSelect.addEventListener("change", this.boundUpdate)
    // Choices.js may wrap the select; listen to addItem on the Choices container
    const choicesContainer = this.sourceSelect.closest("[data-controller*='multiselect']")
    if (choicesContainer) {
      choicesContainer.addEventListener("addItem", this.boundUpdate)
      choicesContainer.addEventListener("removeItem", this.boundUpdate)
    }
    this.updatePathField()
  }

  disconnect() {
    if (this.sourceSelect) this.sourceSelect.removeEventListener("change", this.boundUpdate)
    const choicesContainer = this.sourceSelect?.closest("[data-controller*='multiselect']")
    if (choicesContainer) {
      choicesContainer.removeEventListener("addItem", this.boundUpdate)
      choicesContainer.removeEventListener("removeItem", this.boundUpdate)
    }
  }

  updatePathField() {
    const value = this.getSourceValue()
    if (value) {
      this.pathInput.value = this.pathForSource(value)
      this.pathInput.disabled = true
    } else {
      this.pathInput.disabled = false
    }
  }

  getSourceValue() {
    if (this.sourceSelect.multiple) {
      return Array.from(this.sourceSelect.selectedOptions)
        .map((opt) => opt.value)
        .filter(Boolean)[0]
    }
    return this.sourceSelect.value
  }

  pathForSource(value) {
    const [type, id] = value.split("-", 2)
    if (type === "VideoResource") return `/videos/${id}`
    if (type === "AudioResource") return `/audios/${id}`
    if (type === "DailySchedule") return "/"
    return ""
  }
}
